<template>
<div>
    <zm-tabs type="card" v-model="tabSelected" @tab-click="handleTabClick">
        <zm-tab-pane label="Resource Collection" name="menu"></zm-tab-pane>
        <zm-tab-pane label="Statement" name="statement"></zm-tab-pane>
    </zm-tabs>
    <router-view></router-view>
</div>
</template>
<script>
export default {
    name: 'statement',
    data () {
        return {
            tabSelected: 'menu'
        }
    },
    created () {
        this.tabSelected = this.$route.name || 'menu'
    },
    methods: {
        handleTabClick (tab, event) {
            if (tab.name === 'menu') {
                this.$router.push('/dashboard/permission/menu')
            } else if (tab.name === 'statement') {
                this.$router.push('/dashboard/permission/statement')
            } else {
                console.log('error')
            }
        }
    }
}
</script>
